/**
 * Promocja „rabat na start" — pula losowania przy odbiciu od limitu ofert.
 *
 * JEDNO źródło prawdy dla frontu (losowanie + copy) i API (whitelist kodów
 * przyjmowanych w `promoCode`). Kod spoza tej listy API ignoruje — inaczej
 * endpoint naliczałby automatycznie DOWOLNY aktywny kod z konta Stripe
 * (partnerskie, wewnętrzne), wysłany ręcznie POST-em.
 *
 * Każdy kod musi istnieć w Stripe jako aktywny promotion code (kupon procentowy,
 * `duration: once` = rabat na pierwszą fakturę). Utworzone 2026-08-23.
 */

export interface PromoStartTier {
  pct: number;
  code: string;
  /** Waga losowania — im wyższa, tym częściej wypada. */
  weight: number;
}

export const PROMO_START_TIERS: readonly PromoStartTier[] = [
  { pct: 10, code: "START10", weight: 50 },
  { pct: 15, code: "START15", weight: 35 },
  { pct: 20, code: "START20", weight: 15 },
];

export const PROMO_START_CODES: readonly string[] = PROMO_START_TIERS.map((tier) => tier.code);

/** Whitelist dla API: tylko kody z puli losowania wolno naliczyć automatycznie. */
export function isAllowedPromoCode(code: string): boolean {
  return PROMO_START_CODES.includes(code);
}
